import { Alert, AlertTitle, Box } from "@mui/material";
import { useIntl } from "react-intl";

export const NotFoundPage = () => {
  const { formatMessage: t } = useIntl();
  return (
    <Box>
      <Alert severity="warning">
        <AlertTitle>
          <strong>{t({ id: "notFound" })}</strong>
        </AlertTitle>
        {t({ id: "pageDoesNotExist" })}
      </Alert>
    </Box>
  );
};
